/**
 * Módulos de estudo de Cartórios.
 *
 * O tipo e o nome de interface moram aqui, no domínio - não no tema. O tema
 * cuida de cor e token; o texto que aparece na tela (card, menu, título) é
 * assunto do domínio, num lugar só, para não divergir entre telas.
 */
export type ModuleKey = 'enac' | 'objective' | 'essay';

export const moduleLabel: Record<ModuleKey, string> = {
  enac: 'Enac',
  objective: '1ª fase - Cartórios',
  essay: '2ª fase - Cartórios',
};

/** Os três arquivos que uma prova distribui em Provas para Imprimir. */
export type ExamFileKey = 'exam' | 'answer-key' | 'edital';

/**
 * O nome de cada arquivo na tela.
 *
 * Mora aqui pelo mesmo motivo do `moduleLabel` logo acima: é texto de domínio, e
 * o backoffice e o site o escrevem lado a lado - o admin na gaveta de quem
 * baixou, o site no seletor do leitor. Duas cópias divergiriam no dia em que
 * "Gabarito" virasse "Gabarito oficial" de um lado só.
 */
export const examFileLabel: Record<ExamFileKey, string> = {
  exam: 'Prova',
  'answer-key': 'Gabarito',
  edital: 'Edital',
};
